module.exports = __webpack_public_path__ + "img/L1060606.39c4ced4.jpg";